/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ADD_LOCAL_RESERVATION, DELETE_LOCAL_RESERVATION } from '../constants/actions';

export const initialState = {
    reservation: null,
};

export const localReservationReducers = (state = initialState, action) => {
    switch (action?.type) {
        case ADD_LOCAL_RESERVATION:
            return {
                ...state,
                reservation: action?.payload,
            };
        case DELETE_LOCAL_RESERVATION:
            return {
                ...state,
                reservation: null,
            };
        default:
            return state;
    }
};
